import { createSlice } from "@reduxjs/toolkit";
import { InitialMoldFormData } from "../../ConstantData/InitialData";

const moldSlice = createSlice({
  name: "mold",
  initialState: {
    moldList: [],
    dataEdit: {},
    errorData: {},
    isError: false,
    initialData: InitialMoldFormData,
  },
  reducers: {
    getAllMold: (state, action) => {
      state.moldList = action.payload;
    },
    getMold: () => {},
    getMoldDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state) => {
      state.initialData = { ...InitialMoldFormData };
    },
    updateMold: (state, action) => {},
    deleteMold: () => {},
  },
});

export const moldSliceAction = moldSlice.actions;

export default moldSlice.reducer;
